var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30937 2.30938L11.1469 6.14687C11.3719 6.37187 11.5 6.68125 11.5 7C11.5 7.31875 11.3719 7.62812 11.1469 7.85312L7.30937 11.6906C7.10938 11.8906 6.84062 12 6.55937 12C5.975 12 5.5 11.525 5.5 10.9406V9H1.5C0.946875 9 0.5 8.55313 0.5 8V6C0.5 5.44688 0.946875 5 1.5 5H5.5V3.05937C5.5 2.475 5.975 2 6.55937 2C6.84062 2 7.10938 2.1125 7.30937 2.30938ZM11.5 12H13.5C14.0531 12 14.5 11.5531 14.5 11V3C14.5 2.44688 14.0531 2 13.5 2H11.5C10.9469 2 10.5 1.55313 10.5 1C10.5 0.446875 10.9469 0 11.5 0H13.5C15.1562 0 16.5 1.34375 16.5 3V11C16.5 12.6562 15.1562 14 13.5 14H11.5C10.9469 14 10.5 13.5531 10.5 13C10.5 12.4469 10.9469 12 11.5 12Z",
    fill: "#0D6E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.b88e04a5cbf8aa8ce1ada9054df0197b.svg";
export { ForwardRef as ReactComponent };